import React, { useState } from "react";
//#region types
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { FormFieldProps, SelectionTileExtraProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import SelectionTiles from "../../selection/selectionTiles";
//#endregion

function SelectionTileFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, field, value, handleOnChangeCustom, handleOnBlurCustom } = props;

  React.useImperativeHandle(props.fieldRef, () => ({
    change: (selectedItems?: SelectionItem[]) => {
      onChangeHandler(selectedItems ?? []);
    },
  }));

  const extraProps = field.extraProps as SelectionTileExtraProps;
  const [selectedItem, setSelectedItem] = useState<SelectionItem | undefined>(
    extraProps.items?.find((x) => x.id === value)
  );

  const onChangeHandler = (selectedItems: SelectionItem[]) => {
    const currSelectedItem = selectedItems[0];
    setSelectedItem(currSelectedItem);

    handleOnChangeCustom(name, currSelectedItem?.id as number, true);
    handleOnBlurCustom(name);
  };

  return (
    <SelectionTiles
      title={""}
      items={extraProps.items}
      value={selectedItem ? [selectedItem] : []}
      onChange={onChangeHandler}
      hideViewAll={true}
    />
  );
}

export default SelectionTileFormField;
